module.exports = __webpack_public_path__ + "static/media/kaligreen.2da60333.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/cenicilla_fresa/preventiva/kaligreen.png
// module id = 1550
// module chunks = 3